import { render } from "./UserAdmin.vue?vue&type=template&id=3ce6c024&scoped=true"
import script from "./UserAdmin.vue?vue&type=script&lang=js"
export * from "./UserAdmin.vue?vue&type=script&lang=js"

import "./UserAdmin.vue?vue&type=style&index=0&id=3ce6c024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce6c024"]])

export default __exports__